import * as constants from 'Constants';
import * as utils from 'Utils';
import modalStore from 'stores/BackInStock/Modal/SubmitModalStore';
import pageStore from 'stores/BackInStock/PageStore';


export function getPayloadQs() {
  let qs = {};

  const cookieId = utils.getCookieId();
  if (cookieId) qs['cookie_id'] = cookieId;

  const platform = utils.getEcommercePlatform();
  if (platform === 'shopware') {
    qs['product_id'] = window.OnVoardData.product ? window.OnVoardData.product.id : null;
  }

  return qs;
}

export function loadBackInStockCustomStyles(el) {
  let styles = require('containers/BackInStock/styles').default;
  let elementId = `ov_app_back_in_stock_styles_${pageStore.id}`;

  // remove existing survey style tag (if there are any)
  let existingTag = document.getElementById(elementId);
  if (existingTag) existingTag.remove();

  // add style tag
  let innerHTML = styles;
  if (utils.isProduction()) innerHTML = pageStore.cssStyles || "";

  let tag = document.createElement('style');
  tag.id = elementId;
  tag.innerHTML = innerHTML;
  el.after(tag);

  // custom css styles
  const modalConfig = pageStore.modalConfig;
  if (modalConfig.customCssStyles) {
    elementId = `ov_app_back_in_stock_custom_styles_${pageStore.id}`;
    existingTag = document.getElementById(elementId);
    if (existingTag) existingTag.remove();

    tag = document.createElement('style');
    tag.id = elementId;
    tag.innerHTML = modalConfig.customCssStyles;
    el.after(tag);
  }

  // add css classes
  if (modalConfig.cssClasses && modalConfig.cssClasses.length) {
    modalConfig.cssClasses.forEach((cssClass) => {
      if (el.classList.contains(cssClass)) return;
      el.classList.add(cssClass);
    })
  }
}

export function checkValidityWithTags(tags) {
  if (!tags) return true;
  if (!pageStore.tagsWhitelist.length && !pageStore.tagsBlacklist.length) return true;

  tags = tags.map((tag) => tag.toLowerCase());

  if (pageStore.tagsBlacklist.length) {
    if (tags.some((tag) => pageStore.tagsBlacklist.includes(tag))) return false;
  }

  if (pageStore.tagsWhitelist.length) {
    if (!(tags.some((tag) => pageStore.tagsWhitelist.includes(tag)))) return false;
  }

  return true;
}

export function formatShopifyProductData(product) {
  const isDefaultVariant = product.variants.length === 1;

  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.title;
  productData['out_of_stock'] = product.available ? false : true;

  const variantsData = [];
  if (!isDefaultVariant) {
    product.variants.forEach((variant) => {
      const variantData = {};
      variantData['id'] = variant.id;
      variantData['title'] = product.has_only_default_variant ? "" : variant.title;
      variantData['out_of_stock'] = variant.available ? false : true;
      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}


export function formatBigCommerceProductData(product) {
  const productData = {};
  productData['id'] = product.entityId;
  productData['title'] = product.name;
  productData['out_of_stock'] = product.inventory.isInStock ? false : true;

  let getVariantName = (variant) => {
    let values = [];
    variant.options.forEach((option) => {
      option.values.forEach((optValue) => {
        values.push(optValue.label);
      })
    })

    return values.join("/");
  };

  const variantsData = [];
  if (product.variants) {
    product.variants.forEach((variant) => {
      let variantId = variant.entityId;
      let variantName = getVariantName(variant);
      if (!variantId || !variantName) return;

      const variantData = {};
      variantData['id'] = variantId;
      variantData['title'] = variantName;
      variantData['out_of_stock'] = variant.inventory && !variant.inventory.isInStock ? true : false;
      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}

export function formatEasyStoreProductData(product) {
  const isDefaultVariant = product.variants.length === 1;

  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.title;
  productData['out_of_stock'] = product.available ? false : true;

  const variantsData = [];
  if (!isDefaultVariant) {
    product.variants.forEach((variant) => {
      const variantData = {};
      variantData['id'] = variant.id;
      variantData['title'] = isDefaultVariant ? "" : variant.title;
      variantData['out_of_stock'] = variant.available ? false : true;
      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}


export function formatShoplineProductData(product) {
  const isDefaultVariant = 1 >= product.variants.length;

  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.title;

  if (typeof product.available !== 'undefined') {
    productData['out_of_stock'] = product.available ? false : true;
  }

  if (typeof productData.out_of_stock === 'undefined') {
    if (typeof product.sold_out !== 'undefined') {
      productData['out_of_stock'] = product.sold_out;
    }
  }

  const variantsData = [];
  if (!isDefaultVariant) {
    product.variants.forEach((variant) => {
      const variantData = {};
      variantData['id'] = variant.id;
      variantData['title'] = isDefaultVariant ? "" : variant.title;
      variantData['out_of_stock'] = true;

      if (typeof variant.available !== 'undefined') {
        variantData['out_of_stock'] = variant.available ? false : true;
      }

      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}

export function formatShopwareProductData(product) {
  const isDefaultVariant = !product.variants || product.variants.length === 0;

  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.name;
  productData['out_of_stock'] = 0 >= product.available_stock;

  const variantsData = [];
  if (!isDefaultVariant) {
    product.variants.forEach((variant) => {
      const variantData = {};
      variantData['id'] = variant.id;
      variantData['title'] = isDefaultVariant ? "" : variant.name;
      variantData['out_of_stock'] = 0 >= variant.available_stock;
      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}


export function formatWixProductData(product) {
  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.name;
  productData['out_of_stock'] = !product.isInStock;

  let optionsSelections = [];
  product.options.forEach((option) => {
    option.selections.forEach((selection) => {
      optionsSelections.push(selection);
    })
  })

  let getVariantName = (item) => {
    let values = [];
    item.optionsSelections.forEach((selectionId, idx) => {
      let selection = optionsSelections.filter((row) => row.id === selectionId)[0];
      if (!selection) return;
      values.push(selection.key);
    })

    return values.join(" / ");
  };

  const variantsData = [];
  product.productItems.forEach((item) => {
    if (!item.id || item.id.startsWith("00000")) return;

    const variantData = {};
    variantData['id'] = item.id;
    variantData['title'] = getVariantName(item);
    variantData['out_of_stock'] = 0 >= item.inventory.quantity;
    variantsData.push(variantData);
  })

  productData['variants'] = variantsData
  return productData;
}


export function formatWooCommerceProductData(product) {
  const isDefaultVariant = product.variations.length === 0;

  const productData = {};
  productData['id'] = product.id;
  productData['title'] = product.name;
  productData['out_of_stock'] = product.stock_status === 'outofstock';

  const variantsData = [];
  if (!isDefaultVariant) {
    product.variations.forEach((variation) => {
      const variantData = {};
      variantData['id'] = variation.id;
      variantData['title'] = isDefaultVariant ? "" : variation.name;
      variantData['out_of_stock'] = variation.stock_status === 'outofstock';
      variantsData.push(variantData);
    })
  }

  productData['variants'] = variantsData
  return productData;
}


export async function loadProductData() {
  if (!utils.isProduction()) return;
  let ovData = window.OnVoardData || window.OnVoardBackInStockData;

  if (pageStore.isShopify) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const template = ovData.template;
    const product = ovData.product;

    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatShopifyProductData(product);
    await pageStore.deserializeProduct(productData);
  }

  if (pageStore.isBigCommerce) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const pageType = ovData.page_type;
    let product = ovData.product;

    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    let bcUtils = await import('common/bigcommerce-utils');
    bcUtils.loadStorefrontProductData(async (sfProduct) => {
      const productData = formatBigCommerceProductData(sfProduct);
      await pageStore.deserializeProduct(productData);
    });
  }

  if (pageStore.isEasyStore) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const template = ovData.template;
    const product = ovData.product;

    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatEasyStoreProductData(product);
    await pageStore.deserializeProduct(productData);
  }

  if (pageStore.isShopline) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const product = ovData.product;
    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatShoplineProductData(product);
    await pageStore.deserializeProduct(productData);
  }

  if (pageStore.isShopware) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const product = ovData.product;
    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    // wait until variants loaded
    let handle = window.setInterval(async () => {
      if (window.OnVoardData.product && window.OnVoardData.product.variantsLoaded) {
        clearInterval(handle);
        const productData = formatShopwareProductData(window.OnVoardData.product);
        await pageStore.deserializeProduct(productData);
        return;
      }
    }, 200);
  }

  if (pageStore.isWix) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const pageType = ovData.page_type;
    const product = ovData.product;

    if (!product || !product.id) return;
    const productData = formatWixProductData(product);
    await pageStore.deserializeProduct(productData);
  }

  if (pageStore.isWooCommerce) {
    if (!ovData) {
      console.error(`Missing "OnVoardData" in window object, skip loading product data for BackInStock.`);
      return;
    }

    const pageType = ovData.page_type;
    const product = ovData.product;

    if (!product || !product.id) return;
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatWooCommerceProductData(product);
    await pageStore.deserializeProduct(productData);
  }
}

export function isProductPage() {
  if (!utils.isProduction()) return false;
  let ovData = window.OnVoardData || window.OnVoardBackInStockData;

  if (pageStore.isShopify) {
    if (!ovData) return false;
    return ovData.page_type === "product";
  }

  if (pageStore.isBigCommerce) {
    if (!ovData) return false;
    return ovData.page_type === "product";
  }

  if (pageStore.isEasyStore) {
    if (!ovData) return false;
    return ovData.template === "product";
  }

  if (pageStore.isShopline) {
    if (!ovData) return false;
    return ovData.page_type === "product";
  }

  if (pageStore.isShopware) {
    if (!ovData) return false;
    if (!ovData || !ovData.product || !ovData.product.id) return false;
    return true;
  }

  if (pageStore.isWix) {
    if (!ovData) return false;
    return ovData.page_type === "product";
  }

  if (pageStore.isWooCommerce) {
    if (!ovData) return false;
    return ovData.page_type === "product";
  }

  return false;
}

export function onModalOpen() {
  const modalConfig = pageStore.modalConfig;
  let ovData = window.OnVoardData || window.OnVoardBackInStockData;

  if (pageStore.isShopify) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }

  if (pageStore.isBigCommerce) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }

  if (pageStore.isEasyStore) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }

  if (pageStore.isShopline) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }

  if (pageStore.isShopware) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }

  if (pageStore.isWix) {
    if (!ovData) return;

    const member = ovData.member;
    if (modalConfig.autofillDetails && member && member.email) {
      modalStore.setEmail(member.email);
    }
  }

  if (pageStore.isWooCommerce) {
    if (!ovData) return;

    const customer = ovData.customer;
    if (modalConfig.autofillDetails && customer && customer.email) {
      modalStore.setEmail(customer.email);
    }
  }
}


async function setShopifyProductFromTrigger(el) {
  const productString = el.getAttribute('data-shopify-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatShopifyProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}


async function setBigCommerceProductFromTrigger(el) {
  const productString = el.getAttribute('data-bigcommerce-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatBigCommerceProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}


async function setEasyStoreProductFromTrigger(el) {
  const productString = el.getAttribute('data-easystore-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatEasyStoreProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}


async function setShoplineProductFromTrigger(el) {
  const productString = el.getAttribute('data-shopline-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatShoplineProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}



async function setShopwareProductFromTrigger(el) {
  const productString = el.getAttribute('data-shopware-product');
  if (!productString) return;

  try {
    let data = JSON.parse(productString);
    let product = {};
    let isVariant = data.parentId ? true : false;
    product['id'] = data.parentId || data.id;
    product['name'] = data.translated.name;
    product['available_stock'] = isVariant ? 5 : data.availableStock;
    product['tags'] = data.tags || [];
    product['variants'] = [];


    if (isVariant) {
      let options = data.variation.map((row) => row.option);
      let variantName = options.join("/");
      product.variants.push({"id": data.id, "name": variantName, "available_stock": data.availableStock});
    }

    if (!checkValidityWithTags(product.tags)) return;
    const productData = formatShopwareProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}


async function setWixProductFromTrigger(el) {
  const productString = el.getAttribute('data-wix-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    const productData = formatWixProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}


async function setWooCommerceProductFromTrigger(el) {
  const productString = el.getAttribute('data-woocommerce-product');
  if (!productString) return;

  try {
    const product = JSON.parse(productString);
    if (!checkValidityWithTags(product.tags)) return;

    const productData = formatWooCommerceProductData(product);
    await pageStore.deserializeProduct(productData);
  } catch (error) {
    console.error(error);
  }
}

export async function setProductFromTrigger(target) {
  await setShopifyProductFromTrigger(target);
  await setBigCommerceProductFromTrigger(target);
  await setEasyStoreProductFromTrigger(target);
  await setShoplineProductFromTrigger(target);
  await setShopwareProductFromTrigger(target);
  await setWixProductFromTrigger(target);
  await setWooCommerceProductFromTrigger(target);
}

